import { requiredStringSchema } from "@gigpro/ui/Form/utils";
import * as z from "zod/mini";
import { makeApiResource } from "./resource";

const competencyBaseSchema = makeApiResource({ name: z.string() });

export const skillSchema = makeApiResource({
  name: z.string(),
  description: z.nullish(z.string()),
  competencies: z.optional(z.array(competencyBaseSchema)),
});
export type Skill = z.infer<typeof skillSchema>;

export const skillWithDefaultsSchema = z.extend(skillSchema, {
  default_description: z.nullish(z.string()),
  default_no_experience_required: z.nullish(z.boolean()),
  default_wage_amount: z.nullish(z.coerce.number()),
  recommended_wage_amount: z.nullish(z.coerce.number()),
  average_wage_amount: z.nullish(z.coerce.number()),
  recommended_wage_amount_boosted: z.nullish(z.coerce.number()),
  minimum_wage_amount: z.nullish(z.coerce.number()),
});
export type SkillWithDefaults = z.infer<typeof skillWithDefaultsSchema>;

export const requirementSchema = makeApiResource({
  name: requiredStringSchema,
  category: z.string(),
  skill: z.nullish(z.number()),
});

export type Requirement = z.infer<typeof requirementSchema>;
